import { API } from "@/lib/apiConfig";

const API_BASE = API.miniEsg;
const API_KEY_FALLBACK = import.meta.env.VITE_MINI_ESG_API_KEY || "dev-mini-esg-key";

export const MINI_ESG_TOKEN_KEY = "miniESG_jwt";

export function getMiniEsgApiBase() {
  return API_BASE;
}

export function buildMiniEsgAuthHeaders(): Record<string, string> {
  const token = typeof window !== "undefined" ? localStorage.getItem(MINI_ESG_TOKEN_KEY) : undefined;
  return token ? { Authorization: `Bearer ${token}` } : { "x-api-key": API_KEY_FALLBACK };
}

